<template>
  <div id="header">
    <yd-flexbox>
      <div>
        <router-link to="/ucenter">
          <img
            id="head-img1"
            src="../assets/images/person_cnter.png"
          >
        </router-link>
      </div>
      <yd-flexbox-item
        align="center"
        id="head-nav"
      >
        <router-link
          to="/"
          :class="{head_nav_active:carRange=='outcity'}"
        >
          城际约车
        </router-link>
        <router-link
          to="/incity"
          :class="{head_nav_active:carRange=='incity'}"
        >
          城内约车
        </router-link>
      </yd-flexbox-item>
      <div>
        <router-link to="/shop">
          <img
            id="head-img2"
            src="../assets/images/integral_shop.png"
          >
        </router-link>
      </div>
    </yd-flexbox>
  </div>
</template>

<script>
export default {
  name: "",
  props: ["carRange"],
  data() {
    return {
      carRangem: true
    };
  },
  computed: {},
  created() {},
  mounted() {},
  watch: {},
  methods: {},
  components: {}
};
</script>

<style scoped lang="css">
#header {
  width: 100%;
  height: 1.3rem;
  background-image: url("../assets/images/bg.png");
  background-repeat: no-repeat;
  background-size: 100%;
  padding: 0.48rem 0.3rem 0 0.3rem;
}
#header #head-img1 {
  height: 0.5rem;
  width: 0.47rem;
}
#header #head-img2 {
  height: 0.5rem;
  width: 0.62rem;
}
#header #head-nav {
  text-align: center;
}
#header #head-nav a {
  padding: 0.05rem 0.3rem;
  font-size: 0.31rem;
  color: hsla(0, 0%, 100%, 0.6);
}
#header #head-nav .head_nav_active {
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/Headerm.vue